import {OrderRepository} from '@domain/model/Order/OrderRepository';
import {OrderCommentCommand} from '@domain/model/Order/OrderCommentCommand';

const UpdateOrderComment =
  (orderRepository: OrderRepository) =>
  (comment: OrderCommentCommand): Promise<Record<string, boolean> | null> => {
    if (!comment) {
      return Promise.resolve(null);
    }

    return orderRepository.updateOrderComment(comment);
  };

export {UpdateOrderComment};
